<template>
  <div class="step2-open-account">
    <el-alert
      type="info"
      :closable="false"
      show-icon
      class="custom-alert"
    >
      <div slot="title" class="alert-title">账户开通中，请勿离开，页面稍后会自动刷新</div>
      <div slot="default" class="alert-desc">如有疑问您可通过系统对接群内联系车为家工作人员</div>
    </el-alert>

    <!-- Section 1: 资金收款户主体信息 -->
    <div class="info-section">
      <div class="section-header">
        <div class="blue-bar"></div>
        <span class="section-title">资金收款户主体信息</span>
      </div>

      <div class="info-grid">
        <div class="info-item">
          <span class="label">企业主体全称：</span>
          <span class="value">{{ (entity && entity.corporationName) || '--' }}</span>
        </div>
        <div class="info-item">
          <span class="label">统一社会信用代码：</span>
          <span class="value">{{ (entity && entity.licenceNo) || '--' }}</span>
        </div>
        <div class="info-item">
          <span class="label">法人姓名：</span>
          <span class="value">{{ (entity && entity.legalName) || '--' }}</span>
        </div>

        <div class="info-item">
          <span class="label">法人手机号：</span>
          <span class="value">{{ (entity && entity.legalMobile) || '--' }}</span>
        </div>
        <div class="info-item">
          <span class="label">法人身份证号：</span>
          <span class="value">{{ (entity && entity.legalIdNo) || '--' }}</span>
        </div>
        <div class="info-item">
          <span class="label">联系人姓名：</span>
          <span class="value">{{ (entity && entity.contactName) || '--' }}</span>
        </div>

        <div class="info-item">
          <span class="label">联系人手机号：</span>
          <span class="value">{{ (entity && entity.contactMobile) || '--' }}</span>
        </div>
        <div class="info-item">
          <span class="label">联系地址：</span>
          <span class="value">{{ (entity && entity.contactAddress) || '--' }}</span>
        </div>
      </div>
    </div>

    <!-- Section 2: 进件材料 -->
    <div class="info-section">
      <div class="section-header">
        <div class="blue-bar"></div>
        <span class="section-title">进件材料</span>
      </div>

      <div class="info-grid">
        <div class="info-item">
          <span class="label">支付渠道：</span>
          <span class="value">网商银行</span>
        </div>
        <div class="info-item">
          <span class="label">网商商户编号：</span>
          <span class="value">{{ (entity && entity.merchantNo) || '--' }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'

const props = defineProps({
  entity: {
    type: Object,
    default: () => ({}),
  },
})

const emit = defineEmits(['status-change'])

onMounted(() => {
  emit('status-change')
})

</script>

<style scoped lang="scss">
.step2-open-account {
  padding-top: 10px;
}

.custom-alert {
  margin-bottom: 24px;
  background-color: #E6F7FF;
  border: 1px solid #BAE7FF;

  ::v-deep .el-alert__icon {
    color: #1890FF;
  }

  .alert-title {
    font-size: 14px;
    font-weight: 500;
    color: #303133;
    line-height: 22px;
  }

  .alert-desc {
    font-size: 12px;
    color: #606266;
    line-height: 20px;
    margin-top: 4px;
  }
}

.info-section {
  margin-bottom: 24px;

  .section-header {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    padding-left: 0;

    .blue-bar {
      width: 4px;
      height: 16px;
      background: #409EFF;
      margin-right: 8px;
      border-radius: 2px;
    }

    .section-title {
      font-size: 14px;
      font-weight: 500;
      color: #303133;
    }
  }
}

.info-grid {
  display: flex;
  flex-wrap: wrap;
  margin-left: 12px;

  .info-item {
    width: 33.33%;
    margin-bottom: 16px;
    display: flex;
    align-items: flex-start;
    font-size: 13px;
    line-height: 20px;

    .label {
      color: #909399;
      white-space: nowrap;
      margin-right: 4px;
    }

    .value {
      color: #303133;
      word-break: break-all;
    }

    .link-text {
      color: #409EFF;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>
